import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most tools just pass the component context to their templates, so that's the default
 *  tool.render - by default updates the tool element with markup generated by tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext and update. update is
 *  - identical to render by default, but you can override it. the update lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "html-editor",

    /**
     * @description The template file to use to load and render the component.
     * @see html-editor-template.hbs
     */
    templateId: "html-editor-template",

    /**
     * @name update
     * @description
     * Manipulate the context of this element so that it always perpetuates in
     *  the correct state.
     * @param {HTMLElement} element
     * @param {object} context
     */
    update: function (element, context) {
      this.updateInput("textarea");
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      this.listenToInput("textarea");
    },

    /**
     * @name bind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function (element) {
      this.disableInput("textarea");
    },
  });
})();
